<template>
  <h1>astigmatisme</h1>
</template>

<script>
export default {};
</script>
